import BrandHeader from './BrandHeader';

function AppShell({ children }) {
  return (
    <main className="app-shell">
      <div className="matrix-glow matrix-glow-left" />
      <div className="matrix-glow matrix-glow-right" />
      <section className="screen-card">
        <BrandHeader />
        {children}
      </section>
    </main>
  );
}

export default AppShell;
